import { createFileRoute } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import PartsCindyChat from "@/components/parts/PartsCindyChat";

const TITLE = "Parts Cindy Sandbox | Rex & Sons RVs";
const DESCRIPTION =
  "Internal testing sandbox for the Rex & Sons RVs parts assistant, catalog lookup, fitment checks and parts-team takeover.";

function PartsCindySandboxPage() {
  const [sessionKey, setSessionKey] = useState<string | undefined>(undefined);

  useEffect(() => {
    if (typeof window === "undefined") return;
    const param = new URLSearchParams(window.location.search).get("session");
    setSessionKey(param || `parts-sbx-${Date.now()}-${Math.random().toString(36).slice(2)}`);
  }, []);

  return (
    <main className="mx-auto flex min-h-screen w-full max-w-3xl flex-col gap-4 px-4 py-8">
      <header>
        <h1 className="font-heading text-2xl font-bold text-foreground">Parts Cindy Sandbox</h1>
        <p className="text-sm text-muted-foreground">
          Testing page for the parts assistant. Ask for a part, a price, or a fitment check, then use “Talk to the parts
          team” to test the alert and takeover. These chats show up under Parts admin → Chats.
        </p>
      </header>
      {sessionKey && <PartsCindyChat variant="panel" sandbox sessionKey={sessionKey} />}
    </main>
  );
}

export const Route = createFileRoute("/parts-cindy-sandbox")({
  component: PartsCindySandboxPage,
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESCRIPTION },
      { name: "robots", content: "noindex, nofollow" },
      { property: "og:type", content: "website" },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESCRIPTION },
      { name: "twitter:card", content: "summary" },
      { name: "twitter:title", content: TITLE },
      { name: "twitter:description", content: DESCRIPTION },
    ],
  }),
});
